import { gql } from '@apollo/client';

export const GET_DIVISIONS = gql(/* GraphQL */ `
    query GetDivisions {
        getDivisions {
            id
            name
            sapId
        }
    }
`);

export default GET_DIVISIONS;
